import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

const WOOP_ORGANIZATION_AGENT_STATUSES_QUERY_KEY =
  'woop-organization-agent-statuses';

type UseQueryArgs = {
  organizationId: string;
};

export const getWorkloadOrganizationAgentStatusesQueryKey = (params: {
  organizationId: string;
}) =>
  [WOOP_ORGANIZATION_AGENT_STATUSES_QUERY_KEY, params.organizationId] as const;

const getWorkloadOrganizationAgentStatusesQueryOptions = ({
  organizationId,
}: UseQueryArgs) =>
  queryOptions({
    queryKey: getWorkloadOrganizationAgentStatusesQueryKey({ organizationId }),
    queryFn: async () => {
      const { data } =
        await apiClient.workloadOptimization.getOrganizationAgentStatuses({
          organizationId,
        });
      return data.clusterAgentStatuses;
    },
  });

export const useWorkloadOrganizationAgentStatuses = (args: UseQueryArgs) => {
  const { isLoading, data, error, refetch } = useQuery(
    getWorkloadOrganizationAgentStatusesQueryOptions(args)
  );

  return {
    isLoading,
    data,
    error,
    refetch,
  };
};
